import PaymentIcon from '@mui/icons-material/Payment';
import ArticleIcon from '@mui/icons-material/Article';
import Schedule from '@mui/icons-material/Schedule';
import Phone from '@mui/icons-material/Phone';
import * as theme from '../../../theme';
import PlayCircle from '@mui/icons-material/PlayCircle';
import MailIcon from '@mui/icons-material/Mail';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';

export default function OnboardingStatusItem({ children, ...props }) {
  const getColor = (status) => {
    return status ? 'on' : 'off';
  };

  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <div className={'cardLink'} style={{ display: 'flex', flex: 3, width: '100%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => props.actionLink != null ? props.actionLink() : null}>
        <div style={{ ...theme.Container.flexRowFixed, padding: 8 }}>
          <div style={{ flex: 1, fontSize: 14, fontWeight: 500 }}>
            {props.name}
            <br />
            <span style={{ fontWeight: 'normal', fontSize: '0.85em', color: theme.Colors.GrayMedium }}>
              {props.onboarding.trainingCompletedCount + ' of ' + props.onboarding.totalTraining + ' trainings completed'}
            </span>
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', flex: .5, justifyContent: 'right', width: '100%' }}>
        <PlayCircle sx={{ fontSize: 24, marginRight: 1 }} color={getColor(props.onboarding.training)} />
        <ArticleIcon sx={{ fontSize: 24, marginRight: 1 }} color={getColor(props.onboarding.form)} />
        <Schedule sx={{ fontSize: 24, marginRight: 1 }} color={getColor(props.onboarding.scheduleCall)} />
        <Phone sx={{ fontSize: 24, marginRight: 1 }} color={getColor(props.onboarding.completeCall)} />
        <PaymentIcon sx={{ fontSize: 24, marginRight: 1 }} color={getColor(props.onboarding.cardOnFile)} />
        <MailIcon sx={{ fontSize: 24, marginRight: 1 }} color={getColor(props.onboarding.returnKit)} />
        <ContactPhoneIcon sx={{ fontSize: 24 }} color={getColor(props.onboarding.personalScanReview)} />
      </div>
    </div>
  );
}